import { FilterData } from "./components/filter/filterData";
export const DataConfig = {
    exceptionMessage: 'Unable to handle request.',
    menues: [{
        groupid: "1",
        groupname: "Admin",
        items: [{ menuname: 'Role Management', taskid: "27" }, { menuname: 'Create User', taskid: "27" }, {
            menuname: 'Add Role',
            taskid: "27"
        }, { menuname: 'Update User', taskid: "27" }]
    }, {
        groupid: "2",
        groupname: "Manage View",
        items: [{ menuname: 'Fare Chart Master', taskid: "27" }, { menuname: 'Concession Master', taskid: "27" },
        { menuname: 'Route Master', taskid: "27" }, {
            menuname: 'Luggage Master',
            taskid: "27"
        }, { menuname: 'Bus Master', taskid: "27" }]
    },
    {
        groupid: "3",
        groupname: "Allocation",
        items: [{ menuname: 'Duty Planning', taskid: "27" }, {
            menuname: 'Manage ETIM',
            taskid: "27"
        }, { menuname: 'Way Bill Allocation', taskid: "27" }]
    }],
};
export const messages = {
    credentialError: 'You must have entered wrong credentials.',
    exceptionMessage: 'Exception occurred while login'
};
export const errorMessages = {
    data_nt_fnd: "Data not found.",
    err_msg: "Error while fetching data.",
    user_fetching: "Error while fetching users",
    smthn_wrong: "Something went wrong. Please try again",
    retry_msg: "Error while fetching data. Retry!",
    roles_fetching: "Error while fetching Roles",
    depots_fetching: "Error while fetching Depots",
    fares_fetching: "Error while fetching fares",
    no_fares: 'No Fares find to show.'
};

export const storeKeys = {
    isLoggedIn: 'isLoggedIn',
    userDetail: 'userDetail',
    Authorization: 'Authorization',
    redirectMenu: 'redirectMenu',
    expirationTime:'expirationTime'
};

export const paginationKeys = {
    WaybillSummary: 'Waybill-Summary',
    WaybillSignOff: 'Waybill-SignOff',
    Collection: 'Collection',
    FieldAuditOverview: 'Field-Audit-Overview',
    FieldAuditCardOverview: 'Field-Audit-Card-Overview',
    CardScanDetail: 'Card-Scan-Detail',
    CardAuditDetail: 'Card-Audit-Detail',
    FieldAuditByCrew: 'Field-Audit-By-Crew',
    BankSheet: 'Bank-Sheet',
    PrePaidCardMaster: 'PrePaidCardMaster',
    SpotTicket: 'SpotTicket',
    RouteRevenueReport:'Route-Reports',
    BankSheetRTGS: 'Bank-RTGS-Sheet',
};

export const durationTime = {
    StartTime: '00:00:00',
    EndTime: '06:00:00'
}


export const languages = {
    all: ["en", "hn"],
    default: 'en'
};
export const emailPatternRegX = "^[\\w-_\\.+]*[\\w-_\\.]\\@([\\w]+\\.)+[\\w]+[\\w]$";
export const mobilePatternRegX = "\\d{10}$";
export const toastOptions = {
    title: "",
    msg: "",
    theme: 'default',
    timeout: 2000,
    position : "bottom-right"
};
export const toastOptionsRightTop = {
    title: "",
    msg: "",
    showClose: false,
    timeout: 3000,
    theme: "default",
    position : "top-right"
};
export const routePaths = {
    index: '',
    login: 'login',
    forgetPassword: 'forgotPassword',
    kyc: 'kyc',
    complaint: 'complaint',
    closeComplaint: 'closeComplaint',
    closedLoopKYC: 'cKYC',
    transactionBalance: 'transactionBalance',
    closedLoopOTP: 'cOTP',
    verifyOtp: 'verify',
    aadhaarDetails: 'aadhaar',
    multiple: 'multiple',
    home: 'home',
    report: 'report',
    cityManagement: 'cityManagement',
    dailyOps: 'dailyOps',
    masterData: 'masterData',
    sessionExpire: 'sessionExpire',
    notFound: '404',
    //createUser: 'createUser',
    users: 'Users',
    createRole: 'createRole',
    manageRole: 'manageRole',
    profile: 'profile',
    vehicle: 'vehicle',
    dashboard: 'dashboard',
    ksrtcPgRecon: 'ksrtcPgRecon',
    vehiclegps: 'masterData/vehiclegps',
    concessionMaster: 'concessionMaster',
    fareMaster: 'masterData/fareMaster',
    luggageMaster: 'masterData/luggageMaster',
    routeandfares: 'masterData/routeandfares',
    routeandfaresChalo: 'masterData/routeandfaresV2',
    crewmaster: 'masterData/crewmaster',
    salaryIncentive: 'masterData/salaryConfig',
    dutyPlanning: 'dutyPlanning',
    dutyPlanningV2: 'dailyOps/dutyPlanningV2',
    assignETIM: 'dailyOps/assignETIM',
    premiumBusWaybill:'dailyOps/premiumBusWaybill',
    registerETIM: 'masterData/registerETIM',
    registerDC: 'masterData/registerDC',
    allocateWaybill: 'allocateWaybill',
    collection: 'dailyOps/collection',
    dashboardReport: 'dashboardReport',
    waybillReportDetail: 'report/waybillDetail',
    acknowledgeSheet: 'acknowledge-sheet',
    waybillsignoffReportDetail: 'report/waybillsignoffDetail',
    tickets: 'report/tickets',
    rideDetail: 'ride-detail',
    conductorDetail: 'conductor-detail',
    revenueReport: 'revenueReport',
    prepaidCardDetailReport: 'report/prepaid-card-detail-report',
    collectionReport: 'collectionReport',
    waybillReport: 'report/waybillReport',
    routeReport: 'report/routeReport',
    waybillsignoff: 'report/waybillsignoff',
    fieldAuditCardOverview: 'report/fieldAuditCard-overview',
    cardScanDetail: 'report/cardScan-detail',
    auditorDetail: 'report/auditor-detail',
    cardAuditDetail: 'report/cardAudit-detail',
    fieldAuditByCrew:'report/fieldAudit-detail',
    bankSheet: 'report/bank-sheet',
    cashierCollection: 'report/cashier-collection',
    loadMaster: 'dailyOps/loadMaster',
    reports: 'reports',
    manageCities: 'cityManagement/manageCities',
    featureFlags: 'cityManagement/featureFlags',
    manageAgencies: 'cityManagement/manageAgencies',
    manageDepots: 'cityManagement/manageDepots',
    riderShip: 'rider-list',
    realTimeData: 'real-time-data',
    prepaidCardReport: 'report/prepaid-cards',
    prepaidCardDetails: 'masterData/prepaid-card-detail',
    prepaidCardsMaster: 'masterData/prepaid-cards-master',
    cardTransactionOnWaybill: 'report/card-transaction',
    stopWiseReport: 'stopwiseReport',
    busWiseReport: 'buswiseReport',
    realTimeReport: 'realTimeReport',
    spotTickets: 'dailyOps/spotTickets',
    wayBillBatteryReport: 'wayBillBatteryReport',
    wayBillBatteryTicketReport: 'wayBillBatteryTicketReport',
    machineBatteryReport: 'machineBatteryReport',
    promoterPassword: 'masterData/promoterPassword',
    etimConfiguration: 'masterData/etimConfigurationNew',
    etimConfigurationNew: 'masterData/etimConfigurationNew',
    dcConfiguration: 'masterData/dcConfiguration',
    depolessOperations: 'depolessOperations',
    tripStatus: 'tripStatus',
    tripStatusDetails: 'trip-status-detail',
    spotTicket: 'report/spotTicket',
    spotticketingDetails: 'report/spotticketing-detail',
    scheduledutyUpload: 'masterData/scheduledutyUpload',
    passManagement: 'passManagement',
    passIssue: 'pass/issue',
    passEdit: 'pass/edit',
    servicedutyUpload: 'masterData/servicedutyUpload',
    scheduleDetail: 'masterData/schedule-detail',
    serviceDetail: 'masterData/service-detail',
    auditLogs: 'masterData/audit-logs',
    servicedutyAdd: 'masterData/servicedutyAdd',
    editServiceDetail: 'masterData/edit-service',
    addNewServiceVersion: 'masterData/addNewServiceVersion',
    pickupDeactivation: 'masterData/pickup-deactivation',
    addPickupPoints: 'masterData/add-pickup-point',
    editPickupPoints: 'masterData/edit-pickup-point',
    changeDepot: 'masterData/change-depot',
    tripTransfer: 'masterData/trip-transfer',
    bulkdutyUpload: 'dailyOps/bulkdutyUpload',
    operator: 'masterData/operator',
    denominationReport: 'report/denominationReport',
    foreignDepot: 'dailyOps/foreignDepot',
    remittance: 'dailyOps/remittance',
    submitRemittance: 'dailyOps/submit-remittance',
    foreignWaybillSignOffReport: 'report/foreignWaybillSignOffReport',
    CashierdailyDenom: 'dailyOps/CashierdailyDenom',
    tapIntapOut: 'dailyOps/tapIntapOut',
    videoAuditOverview:'videoAudit/overview',
    videoAuditConductor:'videoAudit/conductor',
    crewmasterdetails: 'masterData/crewmaster-details',
    videoAuditOverviewDetail:'videoAudit/overviewDetail',
    videoAuditConductorDetail:'videoAudit/conductorDetail',
    routeWiseDetails:'videoAudit/routeWiseDetails',
    bankRtgs: 'report/bank-rtgs',
    videoAuditOverviewDetailVideo:'videoAudit/overviewDetailVideo',
    manualDataEntry: 'report/banksheet-manual-entry',
};

export const reportRoutes = {
    waybillReportDetail: 'waybillDetail',
    waybillsignoffReportDetail: 'waybillsignoffDetail',
    tickets: 'tickets',
    prepaidCardDetailReport: 'prepaid-card-detail-report',
    waybillReport: 'waybillReport',
    waybillsignoff: 'waybillsignoff',
    cashierCollection: 'cashier-collection',
    prepaidCardReport: 'prepaid-cards',
    prepaidCardDetails: 'prepaid-card-detail',
    cardTransactionOnWaybill: 'card-transaction',
    spotTicket: 'spotTicket',
    spotticketingDetails: 'spotticketing-detail',
    denominationReport: 'denominationReport',
    foreignWaybillSignOffReport: 'foreignWaybillSignOffReport',
    routeReport:'routeReport',
    fieldAuditCardOverview: 'fieldAuditCard-overview',
    cardScanDetail:'cardScan-detail',
    auditorDetail: 'auditor-detail',
    cardAuditDetail: 'cardAudit-detail',
    fieldAuditByCrew:'fieldAudit-detail',
    bankSheet: 'bank-sheet',
    bankRtgs: 'bank-rtgs',
    manualDataEntry: 'banksheet-manual-entry',
}
export const videoAuditReports = {
    overview:'overview',
    conductor:'conductor',
    conductorDetail:'conductorDetail',
    overviewDetail:'overviewDetail',
    overviewDetailVideo:'overviewDetailVideo',
    routeWiseDetails:'routeWiseDetails'
}

export const keysToUrls = {
    "Role Management": routePaths.manageRole,
    //"Create User": routePaths.createUser,
    "Roles": routePaths.createRole,
    "Users": routePaths.users,
    "default": routePaths.index,
    "Fare Chart Master": routePaths.fareMaster,
    "Concession Master": routePaths.concessionMaster,
    "Route & Fares": routePaths.routeandfares,
    "Route & Fares CHALO": routePaths.routeandfaresChalo,

    "Crew Master": routePaths.crewmaster,
    "Luggage Master": routePaths.luggageMaster,
    'Vehicle': routePaths.vehicle,
    'Vehicle Master': routePaths.vehiclegps,
    'Duty Planning': routePaths.dutyPlanning,
    'Waybills': routePaths.dutyPlanningV2,
    'Auditor': routePaths.assignETIM,
    'Premium Bus Waybill':routePaths.premiumBusWaybill,
    'ETIM': routePaths.registerETIM,
    'Driver Console': routePaths.registerDC,
    'Duty Allocation': routePaths.allocateWaybill,
    'Collection': routePaths.collection,
    'Load Master': routePaths.loadMaster,
    'Reconciliation': routePaths.reports,
    'Collections': routePaths.collectionReport,
    'Waybills Summary': routePaths.waybillReport,
    'Waybill Sign-off': routePaths.waybillsignoff,
    'Field Audit overview': routePaths.fieldAuditCardOverview,
    'Field Audit Overview': routePaths.fieldAuditCardOverview,
    'Card Scan Detail':routePaths.cardScanDetail,
    'Bank Sheet': routePaths.bankSheet,
    'Cashier Collection': routePaths.cashierCollection,
    'DashBoard': routePaths.dashboardReport,
    'Revenue': routePaths.revenueReport,
    'Conductor Wise Report': routePaths.collectionReport,
    'City': routePaths.manageCities,
    'System flag': routePaths.featureFlags,
    'Account': routePaths.manageAgencies,
    'Depot': routePaths.manageDepots,
    'Ridership': routePaths.riderShip,
    'Prepaid Card Report': routePaths.prepaidCardReport,
    'Prepaid Card Master': routePaths.prepaidCardsMaster,
    'Real Time Report': routePaths.realTimeReport,
    'Spot Tickets': routePaths.spotTickets,
    'Waybill Battery Report': routePaths.wayBillBatteryReport,
    'ETIM Battery Report': routePaths.machineBatteryReport,
    'Promoter Password': routePaths.promoterPassword,
    'Etim Configuration': routePaths.etimConfigurationNew,
    'Driver Console Configuration': routePaths.dcConfiguration,
    'Etim ConfigurationNew': routePaths.etimConfigurationNew,
    'Duty Start Report': routePaths.depolessOperations,
    'Trip Status Report': routePaths.tripStatus,
    'Spot Ticket': routePaths.spotTicket,
    'Schedule Master': routePaths.scheduledutyUpload,
    'Service Master': routePaths.servicedutyUpload,
    'Duty Upload': routePaths.bulkdutyUpload,
    'Operator': routePaths.operator,
    'Denomination Wise Collection': routePaths.denominationReport,
    'Foreign Depot': routePaths.foreignDepot,
    'Partial Remittance': routePaths.remittance,
    'Foreign Depot Waybill Sign-Off': routePaths.foreignWaybillSignOffReport,
    'Cashier Daily Denominations': routePaths.CashierdailyDenom,
    'TapIn TapOut': routePaths.tapIntapOut,
    'Route Revenue Report':routePaths.routeReport,
    'Overview':routePaths.videoAuditOverview,
    'Conductor':routePaths.videoAuditConductor,
    'Routes':routePaths.routeWiseDetails,
    'Crew Master Details':routePaths.crewmasterdetails,
    'Bank RTGS Report': routePaths.bankRtgs,
    'Pass Management': routePaths.passManagement



};
export const urlToKeys = {
    [`/${routePaths.home}/${routePaths.manageRole}`]: "Role Management",
    [`/${routePaths.home}/${routePaths.createRole}`]: "Roles",
    [`/${routePaths.home}/${routePaths.users}`]: "Users",
    [`/${routePaths.home}/${routePaths.registerETIM}`]: 'ETIM',
    [`/${routePaths.home}/${routePaths.registerDC}`]: 'Driver Console',
    [`/${routePaths.home}/${routePaths.fareMaster}`]: "Fare Chart Master",
    [`/${routePaths.home}/${routePaths.concessionMaster}`]: "Concession Master",
    [`/${routePaths.home}/${routePaths.routeandfares}`]: "Route & Fares",
    [`/${routePaths.home}/${routePaths.routeandfaresChalo}`]: "Route & Fares CHALO",
    [`/${routePaths.home}/${routePaths.crewmaster}`]: "Crew Master",
    [`/${routePaths.home}/${routePaths.luggageMaster}`]: "Luggage Master",
    [`/${routePaths.home}/${routePaths.vehicle}`]: 'Vehicle',
    [`/${routePaths.home}/${routePaths.vehiclegps}`]: 'Vehicle Master',
    [`/${routePaths.home}/${routePaths.dutyPlanning}`]: 'Duty Planning',
    [`/${routePaths.home}/${routePaths.dutyPlanningV2}`]: 'Waybills',
    [`/${routePaths.home}/${routePaths.assignETIM}`]: 'Auditor',
    [`/${routePaths.home}/${routePaths.premiumBusWaybill}`]: 'Premium Bus Waybill',
    [`/${routePaths.home}/${routePaths.allocateWaybill}`]: 'Duty Allocation',
    [`/${routePaths.home}/${routePaths.collection}`]: 'Collection',
    [`/${routePaths.home}/${routePaths.loadMaster}`]: 'Load Master',
    [`/${routePaths.home}/${routePaths.reports}`]: 'Reconciliation',
    [`/${routePaths.home}/${routePaths.waybillReport}`]: 'Waybills Summary',
    [`/${routePaths.home}/${routePaths.routeReport}`]: 'Route Revenue Report',
    [`/${routePaths.home}/${routePaths.waybillsignoff}`]: 'Waybill Sign-off',
    [`/${routePaths.home}/${routePaths.fieldAuditCardOverview}`]: 'Field Audit overview',
    [`/${routePaths.home}/${routePaths.fieldAuditCardOverview}`]: 'Field Audit Overview',
    [`/${routePaths.home}/${routePaths.cardScanDetail}`]: 'Card scan detail',
    [`/${routePaths.home}/${routePaths.bankSheet}`]: 'Bank Sheet',
    [`/${routePaths.home}/${routePaths.cashierCollection}`]: 'Cashier Collection',
    [`/${routePaths.home}/${routePaths.riderShip}`]: 'Ridership',
    [`/${routePaths.home}/${routePaths.dashboardReport}`]: 'DashBoard',
    [`/${routePaths.home}/${routePaths.revenueReport}`]: 'Revenue',
    [`/${routePaths.home}/${routePaths.collectionReport}`]: 'Conductor Wise Report',
    [`/${routePaths.home}/${routePaths.manageCities}`]: 'City',
    [`/${routePaths.home}/${routePaths.featureFlags}`]: 'System flag',
    [`/${routePaths.home}/${routePaths.manageAgencies}`]: 'Account',
    [`/${routePaths.home}/${routePaths.manageDepots}`]: 'Depot',
    [`/${routePaths.home}/${routePaths.prepaidCardReport}`]: 'Prepaid Card Report',
    [`/${routePaths.home}/${routePaths.prepaidCardsMaster}`]: 'Prepaid Card Master',
    [`/${routePaths.home}/${routePaths.realTimeReport}`]: 'Real Time Report',
    [`/${routePaths.home}/${routePaths.spotTickets}`]: 'Spot Tickets',
    [`/${routePaths.home}/${routePaths.wayBillBatteryReport}`]: 'Waybill Battery Report',
    [`/${routePaths.home}/${routePaths.machineBatteryReport}`]: 'ETIM Battery Report',
    [`/${routePaths.home}/${routePaths.promoterPassword}`]: 'Promoter Password',
    [`/${routePaths.home}/${routePaths.etimConfiguration}`]: 'Etim ConfigurationNew',
    [`/${routePaths.home}/${routePaths.etimConfigurationNew}`]: 'Etim ConfigurationNew',
    [`/${routePaths.home}/${routePaths.dcConfiguration}`]: 'Driver Console Configuration',
    [`/${routePaths.home}/${routePaths.depolessOperations}`]: 'Duty Start Report',
    [`/${routePaths.home}/${routePaths.tripStatus}`]: 'Trip Status Report',
    [`/${routePaths.spotTicket}/${routePaths.spotTicket}`]: 'Spot Ticket',
    [`/${routePaths.scheduledutyUpload}/${routePaths.scheduledutyUpload}`]: 'Schedule Master',
    [`/${routePaths.scheduledutyUpload}/${routePaths.servicedutyUpload}`]: 'Service Master',
    [`/${routePaths.bulkdutyUpload}/${routePaths.bulkdutyUpload}`]: 'Duty Upload',
    [`/${routePaths.home}/${routePaths.operator}`]: 'Operator',
    [`/${routePaths.home}/${routePaths.denominationReport}`]: 'Denomination Wise Collection',
    [`/${routePaths.home}/${routePaths.foreignDepot}`]: 'Foreign Depot',
    [`/${routePaths.home}/${routePaths.remittance}`]: 'Partial Remittance',
    [`/${routePaths.home}/${routePaths.foreignWaybillSignOffReport}`]: 'Foreign Depot Waybill Sign-Off',
    [`/${routePaths.home}/${routePaths.CashierdailyDenom}`]: 'Cashier Daily Denominations',
    [`/${routePaths.home}/${routePaths.tapIntapOut}`]: 'TapIn TapOut',
    [`/${routePaths.home}/${routePaths.videoAuditOverview}`]:'Overview',
    [`/${routePaths.home}/${routePaths.videoAuditConductor}`]:'Conductor',
    [`/${routePaths.home}/${routePaths.routeWiseDetails}`]:'Routes',
    [`/${routePaths.home}/${routePaths.crewmasterdetails}`]: "Crew Master Details",
    [`/${routePaths.home}/${routePaths.bankRtgs}`]: 'Bank RTGS Report',
    [`/${routePaths.home}/${routePaths.passManagement}`]: 'Pass Management'

};
export const staticPermission = {
  [`/${routePaths.home}/${routePaths.profile}`]: true,
  [`/${routePaths.home}/${routePaths.dashboard}`]: true,
    [`/${routePaths.home}/${routePaths.ksrtcPgRecon}`]: true,
  [`/${routePaths.home}`]: true,
  [`/${routePaths.home}/${routePaths.waybillReportDetail}`]: true,
  [`/${routePaths.home}/${routePaths.acknowledgeSheet}`]: true,
  [`/${routePaths.home}/${routePaths.waybillsignoffReportDetail}`]: true,
  [`/${routePaths.home}/${routePaths.auditorDetail}`]: true,
  [`/${routePaths.home}/${routePaths.cardAuditDetail}`]: true,
  [`/${routePaths.home}/${routePaths.fieldAuditByCrew}`]: true,
  [`/${routePaths.home}/${routePaths.tickets}`]: true,
  [`/${routePaths.home}/${routePaths.conductorDetail}`]: true,
  [`/${routePaths.home}/${routePaths.rideDetail}`]: true,
  [`/${routePaths.home}/${routePaths.realTimeData}`]: true,
  [`/${routePaths.home}/${routePaths.prepaidCardDetails}`]: true,
  [`/${routePaths.home}/${routePaths.prepaidCardDetailReport}`]: true,
  [`/${routePaths.home}/${routePaths.cardTransactionOnWaybill}`]: true,
  [`/${routePaths.home}/${routePaths.stopWiseReport}`]: true,
  [`/${routePaths.home}/${routePaths.busWiseReport}`]: true,
  [`/${routePaths.home}/${routePaths.realTimeReport}`]: true,
  [`/${routePaths.home}/${routePaths.spotTickets}`]: true,
  [`/${routePaths.home}/${routePaths.wayBillBatteryReport}`]: true,
  [`/${routePaths.home}/${routePaths.wayBillBatteryTicketReport}`]: true,
  [`/${routePaths.home}/${routePaths.machineBatteryReport}`]: true,
  [`/${routePaths.home}/${routePaths.etimConfiguration}`]: true,
  [`/${routePaths.home}/${routePaths.etimConfigurationNew}`]: true,
  [`/${routePaths.home}/${routePaths.depolessOperations}`]: true,
  [`/${routePaths.home}/${routePaths.tripStatus}`]: true,
  [`/${routePaths.home}/${routePaths.tripStatusDetails}`]: true,
  [`/${routePaths.home}/${routePaths.spotTicket}`]: true,
  [`/${routePaths.home}/${routePaths.spotticketingDetails}`]: true,
  [`/${routePaths.home}/${routePaths.scheduledutyUpload}`]: true,
  [`/${routePaths.home}/${routePaths.servicedutyUpload}`]: true,
  [`/${routePaths.home}/${routePaths.scheduleDetail}`]: true,
  [`/${routePaths.home}/${routePaths.serviceDetail}`]: true,
  [`/${routePaths.home}/${routePaths.auditLogs}`]: true,
  [`/${routePaths.home}/${routePaths.servicedutyAdd}`]: true,
  [`/${routePaths.home}/${routePaths.editServiceDetail}`]: true,
  [`/${routePaths.home}/${routePaths.addNewServiceVersion}`]: true,
  [`/${routePaths.home}/${routePaths.pickupDeactivation}`]: true,
  [`/${routePaths.home}/${routePaths.editPickupPoints}`]: true,
  [`/${routePaths.home}/${routePaths.addPickupPoints}`]: true,
  [`/${routePaths.home}/${routePaths.changeDepot}`]: true,
  [`/${routePaths.home}/${routePaths.tripTransfer}`]: true,
  [`/${routePaths.home}/${routePaths.salaryIncentive}`]: true,
  [`/${routePaths.home}/${routePaths.bulkdutyUpload}`]: true,
  [`/${routePaths.home}/${routePaths.denominationReport}`]: true,
  [`/${routePaths.home}/${routePaths.fieldAuditCardOverview}`]: true,
  [`/${routePaths.home}/${routePaths.cardScanDetail}`]: true,
  [`/${routePaths.home}/${routePaths.bankSheet}`]: true,
  [`/${routePaths.home}/${routePaths.foreignDepot}`]: true,
  [`/${routePaths.home}/${routePaths.remittance}`]: true,
  [`/${routePaths.home}/${routePaths.submitRemittance}`]: true,
  [`/${routePaths.home}/${routePaths.foreignWaybillSignOffReport}`]: true,
  [`/${routePaths.home}/${routePaths.CashierdailyDenom}`]: true,
  [`/${routePaths.home}/${routePaths.tapIntapOut}`]: true,
  [`/${routePaths.home}/${routePaths.videoAuditOverview}`]: true,
  [`/${routePaths.home}/${routePaths.videoAuditConductor}`]: true,
  [`/${routePaths.home}/${routePaths.videoAuditOverviewDetail}`]: true,
  [`/${routePaths.home}/${routePaths.videoAuditConductorDetail}`]: true,
  [`/${routePaths.home}/${routePaths.bankRtgs}`]: true,
  [`/${routePaths.home}/${routePaths.videoAuditOverviewDetailVideo}`]: true,
  [`/${routePaths.home}/${routePaths.manualDataEntry}`]: true,
  [`/${routePaths.home}/${routePaths.passIssue}`]: true,
  [`/${routePaths.home}/${routePaths.passEdit}`]: true
};

export const mainMenus = {
    [`/${routePaths.home}/${routePaths.profile}`]:  true,
    [`/${routePaths.home}/${routePaths.dashboard}`]: true,
    [`/${routePaths.home}/${routePaths.ksrtcPgRecon}`]: true,
    [`/${routePaths.home}`]: true,
    [`/${routePaths.home}/${routePaths.registerETIM}`]: true,
    [`/${routePaths.home}/${routePaths.registerDC}`]: true,
    [`/${routePaths.home}/${routePaths.operator}`]: true,
    [`/${routePaths.home}/${routePaths.etimConfigurationNew}`]: true,
    [`/${routePaths.home}/${routePaths.dcConfiguration}`]: true,
    [`/${routePaths.home}/${routePaths.crewmaster}`]: true,
    [`/${routePaths.scheduledutyUpload}/${routePaths.scheduledutyUpload}`]: true,
    [`/${routePaths.scheduledutyUpload}/${routePaths.servicedutyUpload}`]: true,
    [`/${routePaths.bulkdutyUpload}/${routePaths.bulkdutyUpload}`]: true,
    [`/${routePaths.home}/${routePaths.routeandfaresChalo}`]: true,
    [`/${routePaths.home}/${routePaths.vehiclegps}`]: true,
    [`/${routePaths.home}/${routePaths.promoterPassword}`]: true,
    [`/${routePaths.home}/${routePaths.collection}`]: true,
    [`/${routePaths.home}/${routePaths.dutyPlanningV2}`]: true,
    [`/${routePaths.home}/${routePaths.assignETIM}`]: true,
    [`/${routePaths.home}/${routePaths.premiumBusWaybill}`]: true,
    [`/${routePaths.home}/${routePaths.spotTickets}`]: true,
    [`/${routePaths.home}/${routePaths.manageCities}`]: true,
    [`/${routePaths.home}/${routePaths.featureFlags}`]: true,
    [`/${routePaths.home}/${routePaths.manageAgencies}`]: true,
    [`/${routePaths.home}/${routePaths.manageDepots}`]: true,
    [`/${routePaths.home}/${routePaths.crewmasterdetails}`]: true,
    [`/${routePaths.home}/${routePaths.passManagement}`]: true
    
};

export const filterKeys = {
    etim: 'etim',
    conductor: 'conductor',
    driver: 'driver',
    bus: 'bus',
    route: 'route',
    busType: 'busType',
    concession: 'concession',
    status: 'status',
    agency: 'account',
    city: 'city',
    depot: 'depot',
    concessionType: "concessionType",
    role: 'role',
    syncStatus: 'ETIM Sync Status',
    mode:'mode'

};



export const stateDataKeys = ["SIGNOFF", "SUMMARY","PREPAID_CARD","COLLECTION"]

export const Links = {
    LINK_TO_WAYBILL_DETAIL_REPORT: 'waybillDetail',
    LINK_TO_WAYBILLSIGNOFF_DETAIL_REPORT: 'waybillsignoffDetail',
    LINK_TO_CARD_AUDIT_DETAILS_REPORT: 'cardAudit-detail',
    LINK_TO_CARD_SCAN_DETAILS_REPORT: 'cardScan-detail',
    LINK_TO_ACKNOWLEDGE_SHEET: 'acknowledge-sheet',
    LINK_TO_PREPAID_CARD_DETAIL: 'prepaid-card-detail',
    LINK_TO_PREPAID_CARD_DETAIL_REPORT: 'prepaid-card-detail-report',
    LINK_TO_TICKETS: 'tickets',
    LINK_TO_CONDUCTOR_DETAIL: 'conductor-detail',
    LINK_TO_RIDE_DETAIL: 'ride-detail',
    LINK_TO_WAYBILLSUBMIT: 'submit-waybill',
    LINK_TO_REAL_TIME_DATA: 'real-time-data',
    LINK_TO_CARD_TRANS_WAYBILL: 'card-transaction',
    LINK_TO_STOP_WISE_REPORT: routePaths.stopWiseReport,
    LINK_TO_BUS_WISE_REPORT: routePaths.busWiseReport,
    LINK_TO_TRIP_STATUS_REPORT: 'trip-status-detail',
    LINK_TO_SPOT_TICKETING_REPORT: 'spotticketing-detail',
    LINK_TO_ETIM_TICKET_BATTERY_REPORT: routePaths.wayBillBatteryTicketReport,
    LINK_TO_OVERVIEW_DETAIL:'overviewDetail',
    LINK_TO_AUDIT_CONDUCTOR_DETAIL: 'conductorDetail',
    LINK_TO_SCHEDULE_DETAIL: 'schedule-detail',
    LINK_TO_SERVICE_DETAIL: 'service-detail',
    LINK_TO_AUDIT_LOGS: 'audit-logs',
    LINK_TO_EDIT_SERVICE: 'edit-service',
    LINK_TO_ADD_NEW_SERVICE: 'addNewServiceVersion',
    LINK_TO_ADD_SERVICE: 'servicedutyAdd',
    LINK_TO_OVERVIEW_DETAIL_VIDEO:'overviewDetailVideo',
    LINK_TO_SUBMIT_REMITTANCE: 'submit-remittance',
    LINK_TO_REMITTANCE: 'remittance',
    LINK_TO_REMITTANCE_FOR_WAYBILL: 'remittance-for-waybill',
    LINK_TO_PICKUP_DEACTIVATION: 'pickup-deactivation',
    LINK_TO_EDIT_PICKUP_POINT: 'edit-pickup-point',
    LINK_TO_ADD_PICKUP_POINT: 'add-pickup-point',
    LINK_TO_CHANGE_DEPOT: 'change-depot',
    LINK_TO_TRIP_TRANSFER: 'trip-transfer'
};


export enum paginationEnum{
    
    SIGNOFF = <any>"SIGNOFF",
    SUMMARY = <any>"SUMMARY",
    PREPAID_CARD = <any>"PREPAID_CARD",
    COLLECTION = <any>"COLLECTION"

};


export enum SocketEventsEnum {

    //collection sync
    Request_Collection_Sync = <any>"RQCS",
    Ready_To_Collection_Sync = <any>"RCS",
    Request_Master_Sync = <any>"RQMS",
    Collection_Synced = <any>"CS",
    Collection_Syncing_Failed = <any>"CSF",
    Collection_Done = <any>"CSD",

    //when we allocate waybill
    Request_Waybill_Sync = <any>"RQWS",
    Request_Waybill_Cancel = <any>"RQWC",
    Waybill_Cancelled = <any>"WC",
    Waybill_Synced = <any>"WS",
    Waybill_Syncing_Failed = <any>"WSF",

    Device_Not_Registered = <any>"DNR",
    Device_Available = <any>"DA",
    Device_Not_Available = <any>"DNA"
}

export enum TripDirections {
    UP = <any>"UP",
    DOWN = <any>"DOWN",
    BOTH = <any>"BOTH"
}
export enum ETIMStatus {
    Active = <any>"Active",
    Deactivated = <any>"Deactivated",
    Damaged = <any>"Damaged",
    "Under Repair" = <any>"Under Repair"
}
export enum BankDetailsStatus {
    Yes = "YES",
    No = "NO"
}

export const SyncStatus = {
    SYNCED : "Synced",
    NOT_SYNCED : "Not Synced",
    SYNC_FAIL : "Sync Failed"
};
export enum FixedRoles {
    Conductor = <any>"Conductor",
    Driver = <any>"Driver",
    SuperAdmin = <any>"SuperAdmin",
}

export const SocketStateMessages = {
    connection: "You are connected.",
    connectionLost: "",
    trying: "Trying to connect....",
    disconnecting: "You are disconnecting....",
};

export const concessionFilters: FilterData = {
    id: filterKeys.concessionType,
    values: [{ id: 'offer', value: 'Offer' }, { id: 'standard', value: 'Standard' }],
    hideSearch: true,
    selectedID: null,
    selectedValue: null
};
export const routeReportFilters: FilterData = {
    id: filterKeys.mode,
    values: [{ id: 'HISTORIC_DATA', value: 'All Data' }, { id: 'LIVE_DATA', value: 'Live Data' }],
    hideSearch: true,
    selectedID: 'LIVE_DATA',
    selectedValue: null
};

export const TypeData: Array<any> = [{

    "id": 1,
    "value": "Intercity"

},
{

    "id": 2,
    "value": "Intracity"

}];

export const apkVersion = {

    "currentApkVersion": "1.1.200"
};

export const collectionVersion = {

    "currentApkVersion": "1.1.200"
};

export const cityName = {

    "city": "Mumbai"
};

export const menuOrder: any = {
    "Master Data": 1,
    "Daily Ops": 2,
    "Pass Management": 3,
    "Reports": 4,
    "User Management": 5,
    "City Management": 6,
    "Video Audit":7
}

export const ERRORS = {
    NO_DEPOTS_FOUND : "No depots found for selected city & account.",
    NO_AGENCIES_FOUND : "No accounts found for selected city.",
    NO_AGENCIES_FOUND2: "No acounts found for selected agency",
    NO_GPS_AGENCIES_FOUND: "No agencies found for selected city",
    LOGIN_FAIL : "You are not logged in. Please login.",
    NO_CITIES_FOUND : "No cities found for selected account.",

}
export const TOAST_TEXT = {
    SESSION_EXPIRE : "Session Expired. Please login again.",
}
export const states = [
    {
        "State Name": "Andaman and Nicobar Islands",
        "Abbreviation": "AN"
    },
    {
        "State Name": "Andhra Pradesh",
        "Abbreviation": "AP"
    },
    {
        "State Name": "Arunachal Pradesh",
        "Abbreviation": "AR"
    },
    {
        "State Name": "Assam",
        "Abbreviation": "AS"
    },
    {
        "State Name": "Bihar",
        "Abbreviation": "BR"
    },
    {
        "State Name": "Chandigarh",
        "Abbreviation": "CH"
    },
    {
        "State Name": "Chhattisgarh",
        "Abbreviation": "CT"
    },
    {
        "State Name": "Dadra and Nagar Haveli",
        "Abbreviation": "DN"
    },
    {
        "State Name": "Daman and Diu",
        "Abbreviation": "DD"
    },
    {
        "State Name": "Delhi",
        "Abbreviation": "DL"
    },
    {
        "State Name": "Goa",
        "Abbreviation": "GA"
    },
    {
        "State Name": "Gujarat",
        "Abbreviation": "GJ"
    },
    {
        "State Name": "Haryana",
        "Abbreviation": "HR"
    },
    {
        "State Name": "Himachal Pradesh",
        "Abbreviation": "HP"
    },
    {
        "State Name": "Jammu and Kashmir",
        "Abbreviation": "JK"
    },
    {
        "State Name": "Jharkhand",
        "Abbreviation": "JH"
    },
    {
        "State Name": "Karnataka",
        "Abbreviation": "KA"
    },
    {
        "State Name": "Kerala",
        "Abbreviation": "KL"
    },
    {
        "State Name": "Lakshadweep",
        "Abbreviation": "LD"
    },
    {
        "State Name": "Madhya Pradesh",
        "Abbreviation": "MP"
    },
    {
        "State Name": "Maharashtra",
        "Abbreviation": "MH"
    },
    {
        "State Name": "Manipur",
        "Abbreviation": "MN"
    },
    {
        "State Name": "Meghalaya",
        "Abbreviation": "ML"
    },
    {
        "State Name": "Mizoram",
        "Abbreviation": "MZ"
    },
    {
        "State Name": "Nagaland",
        "Abbreviation": "NL"
    },
    {
        "State Name": "Odisha",
        "Abbreviation": "OR"
    },
    {
        "State Name": "Puducherry",
        "Abbreviation": "PY"
    },
    {
        "State Name": "Punjab",
        "Abbreviation": "PB"
    },
    {
        "State Name": "Rajasthan",
        "Abbreviation": "RJ"
    },
    {
        "State Name": "Sikkim",
        "Abbreviation": "SK"
    },
    {
        "State Name": "Tamil Nadu",
        "Abbreviation": "TN"
    },
    {
        "State Name": "Telangana",
        "Abbreviation": "TG"
    },
    {
        "State Name": "Tripura",
        "Abbreviation": "TR"
    },
    {
        "State Name": "Uttar Pradesh",
        "Abbreviation": "UP"
    },
    {
        "State Name": "Uttarakhand",
        "Abbreviation": "UT"
    },
    {
        "State Name": "West Bengal",
        "Abbreviation": "WB"
    }
]

export enum TimeZone {
    KOLKATA = "kolkata, India UTC+05:30",
    Bankok = "Bangkok, Thailand UTC+07:00",
    MANILA = "Manila, Philippines UTC+08:00",
    PERU = "Peru, Lima UTC-05:00",
    CHILE = "Chile, La Serena UTC-04:00",
    SUVA = "Suva, Fiji UTC+12:00"
}

export const languageList = [
    {lang_id: 'en', lang_text: 'English'},
    {lang_id: 'mr', lang_text: 'Marathi'},
    {lang_id: 'tam', lang_text: 'Tamil'},
    {lang_id: 'kn', lang_text: 'Kannada'},
    {lang_id: 'th', lang_text: 'Thai'},
    {lang_id: 'es', lang_text: 'Spanish'},
    {lang_id: 'or', lang_text: 'Odia'},
    {lang_id: 'hi', lang_text: 'Hindi'}
]

export const defaultlanguageList = [
    {id: 1, value: 'en'},
    {id: 2, value: 'mr'},
    {id: 3, value: 'tam'},
    {id: 4, value: 'kn'},
    {id: 4, value: 'th'},
    {id: 5, value: 'es'},
    {id: 6, value: 'or'},
    {id: 7, value: 'hi'}
]

export const farePrecissionList = [
    {id: '1', value: 'ACTUAL'},
    {id: '2', value: 'ROUND_OFF'},
    {id: '3', value: 'CEIL'},
    {id: '4', value: 'FLOOR'}
]

export const allPrintFontList = [
    {id: '1', value: 'IBM PLEX'},
    {id: '2', value: 'DEFAULT'}
]

export const translatedValue={
    "active":"COMMON.ACTIVE",
    "damaged":"COMMON.DAMAGED",
    "deactivated":"COMMON.DEACTIVATED",
    "under repair":"COMMON.UNDER_REPAIR",
    "status":"COMMON.STATUS",
    "blocked":"COMMON.BLOCKED",
    "sold":"COMMON.SOLD",
    "product type":"PREPAID.PRODUCT_TYPE",
    "closed loop":"COMMON.CLOSED_LOOP",
    "ncmc":"COMMON.NCMC",
    "semi closed":"COMMON.SEMI_CLOSED",
    "student pass only":"COMMON.STDNT_PASS_ONLY",
    "auditor":"ETIMCONFIG.TAB3.AUDITOR",
    "conductor":"DUTYPLAN.CONDUCTOR",
    "driver":"DUTYPLAN.DRIVER",
    "promoter":"DUTYPLAN.TYPE",
    "tito":"DUTYPLAN.TITO",
    "roles":"COMMON.ROLES",
    "inactive":"COMMON.INACTIVE",
    "account":"COMMON.AGENCY",
    "city":"COMMON.CITY",
    "etim sync status":"COLLECTION.ETIM_SYNC_STATUS",
    "not synced":"COMMON.NOT_SYNCED",
    "sync failed":"COMMON.SYNC_FAILED",
    "synced":"COMMON.SYNCED",
    "cardtype":"PREPAID_CRD_RPRT.CARD_TYPE",
    "semi closed loop":"COMMON.SEMI_CLOSED_LOOP",
    "semi closed loop-pass only":"COMMON.PASS_ONLY"
}
